// @generated by protoc-gen-es v1.3.3 with parameter "target=js+dts,import_extension=none"
// @generated from file merchant/v1/product.proto (package merchant.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3 } from "@bufbuild/protobuf";

/**
 * Product is the main resource representing a product / service offered by Merchant.
 * Main use of this resource is for payment links.
 *
 * @generated from message merchant.v1.Product
 */
export const Product = proto3.makeMessageType(
  "merchant.v1.Product",
  () => [
    { no: 1, name: "product_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 11, name: "product_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 15, name: "merchant_product_identifier", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 13, name: "product_description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "universal_product_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 14, name: "item_commodity_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 12, name: "stock_keeping_unit", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "image_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "shippable", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 16, name: "is_taxable", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

